import { render, staticRenderFns } from "./RechargePrepaid.vue?vue&type=template&id=0d513cc8&scoped=true&"
import script from "./RechargePrepaid.vue?vue&type=script&lang=js&"
export * from "./RechargePrepaid.vue?vue&type=script&lang=js&"
import style0 from "./RechargePrepaid.vue?vue&type=style&index=0&id=0d513cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d513cc8",
  null
  
)

export default component.exports